// Fetchers for /trends/* endpoints. The Django/Caddy proxy mounts FastAPI
// under `/api/fastapi/`, so paths here match those used by other features
// (see lib/exploreApi for the established pattern).
import { apiFetch } from '../../lib/api';
import type {
  CvePayload,
  DiscoveryPayload,
  GeoPayload,
  InfrastructurePayload,
  PulseDimension,
  PulsePayload,
  RangeKey,
  SectorsPayload,
  SourcesPayload,
  TtpsPayload,
} from './types';

const BASE = '/api/fastapi/trends';

const q = (range: RangeKey) => `?range=${encodeURIComponent(range)}`;

export const fetchPulse = (range: RangeKey, dimension: PulseDimension = 'country') =>
  apiFetch<PulsePayload>(
    `${BASE}/pulse?range=${encodeURIComponent(range)}&dimension=${encodeURIComponent(dimension)}`,
  );

export const fetchInfrastructure = (range: RangeKey) =>
  apiFetch<InfrastructurePayload>(`${BASE}/infrastructure${q(range)}`);

export const fetchCve = (range: RangeKey) =>
  apiFetch<CvePayload>(`${BASE}/cve${q(range)}`);

export const fetchSectors = (range: RangeKey) =>
  apiFetch<SectorsPayload>(`${BASE}/sectors${q(range)}`);

export const fetchGeo = (range: RangeKey) =>
  apiFetch<GeoPayload>(`${BASE}/geo${q(range)}`);

export const fetchTtps = (range: RangeKey) =>
  apiFetch<TtpsPayload>(`${BASE}/ttps${q(range)}`);

export const fetchSources = (range: RangeKey) =>
  apiFetch<SourcesPayload>(`${BASE}/sources${q(range)}`);

export const fetchDiscovery = (range: RangeKey) =>
  apiFetch<DiscoveryPayload>(`${BASE}/discovery${q(range)}`);
